import {useDispatch, useSelector} from "react-redux";
import {
    Alert,
    AppBar,
    Box,
    IconButton,
    Snackbar,
    Toolbar,
    Typography
} from "@mui/material";
import React, {useEffect} from "react";
import ColorConstants from "../../defaults/ColorConstants";
import {setFiscalYearOverridesActive, setFiscalYearOverridesDate} from "../../redux/slices/globalOverridesSlice";
import CloseIcon from "@mui/icons-material/Close";
import {useNavigate} from "react-router";
import FieldNames from "../../defaults/FieldNames.json";
import FiscalYearOverrides from "./FiscalYearOverride";
import FeatureService from "../../services/FeatureService";

const {BlueAlien, WhiteAlien} = ColorConstants;

export default function AdminOverridesPanel({
                                                 setShowMap,
                                                 headerheight
                                             }) {


    const overrides = useSelector((state) => state.globalOverrides);
    const config = useSelector((state) => state.configuration.config);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [fuelsOverrideActive, setFuelsOverrideActive] = React.useState(false);
    const [fuelsOverrideFYDate, setFuelsOverrideFYDate] = React.useState(null);
    const [postFireOverrideActive, setPostFireOverrideActive] = React.useState(false);
    const [postFireOverrideFYDate, setPostFireOverrideFYDate] = React.useState(null);
    const [snackbarOpen, setSnackbarOpen] = React.useState(false);
    const [snackbarMessage, setSnackbarMessage] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');

    const handleEnabledChange = (enabled, isFuels = true) => {
        if (isFuels) {
            setFuelsOverrideActive(enabled);
        } else {
            setPostFireOverrideActive(enabled);
        }
    };

    const handleDateChange = (date, isFuels = true) => {
        if (isFuels) {
            setFuelsOverrideFYDate(date);
        } else {
            setPostFireOverrideFYDate(date);
        }
    };


    useEffect(() => {
        if (overrides) {
            // fuels
            setFuelsOverrideActive(overrides.fuels.fiscalYearOverridesActive)
            setFuelsOverrideFYDate(overrides.fuels.fiscalYearOverridesDate)

            //post fire
            setPostFireOverrideActive(overrides.postFire.fiscalYearOverridesActive)
            setPostFireOverrideFYDate(overrides.postFire.fiscalYearOverridesDate);
        }
    }, [overrides])


    const handleFuelsSaveOverrides = () => {
        dispatch(setFiscalYearOverridesActive({module: 'fuels', isActive: true}));
        dispatch(setFiscalYearOverridesDate({module: 'fuels', date: fuelsOverrideFYDate}));
        const { objectID, enabled, value } = FieldNames.overrideFields;
        const payload = {
            [objectID]: overrides.fuels.objectId,
            [enabled]: fuelsOverrideActive ? 1 : 0,
            [value]: fuelsOverrideFYDate
        }
        applyUpdates(payload);
    }

    const handlePostFireSaveOverrides = () => {
        dispatch(setFiscalYearOverridesActive({module: 'postFire', isActive: true}));
        dispatch(setFiscalYearOverridesDate({module: 'postFire', date: postFireOverrideFYDate}));
        const { objectID, enabled, value } = FieldNames.overrideFields;
        const payload = {
            [objectID]: overrides.postFire.objectId,
            [enabled]: postFireOverrideActive ? 1 : 0,
            [value]: postFireOverrideFYDate
        }
        applyUpdates(payload);
    }

    const applyUpdates = (payload) => {
        setLoading(true);
        FeatureService.updateFeatureAttributes([payload], config.ifprsOverrides[config.env].restEndpoint).then(r => {
            handleUpdateResults(r)
        }).catch(() => openSnackbar('Error saving override.', 'error')).finally(() => setLoading(false));
    }

    const handleUpdateResults = (result) => {
        if (result && result.updateResults) {
            const errors = result.updateResults.filter(res => res.error);
            if (errors.length > 0) {
                openSnackbar('Error saving override.', 'error')
            } else {
                openSnackbar('Override saved successfully.', 'success')
            }
        } else {
            openSnackbar('Error saving override.', 'error')
        }
    }

    const openSnackbar = (message, severity = 'success') => {
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setSnackbarOpen(true);
    }

    const handleClose = () => {
        setShowMap(true);
        navigate("/home");
    };

    return (
        <Box sx={{
            height: "100%",
            width: "100%",
            minWidth: "10px"
        }}
        >
            <AppBar
                sx={{position: "relative"}}
                style={{backgroundColor: BlueAlien, marginTop: headerheight}}
            >
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                    >
                        <CloseIcon style={{fill: WhiteAlien}}/>
                    </IconButton>
                    <Typography
                        sx={{ml: 2, flex: 1}}
                        variant="h6"
                        component="div"
                        style={{color: WhiteAlien}}
                    >
                        Admin Overrides
                    </Typography>
                </Toolbar>
            </AppBar>
            <FiscalYearOverrides
                isPostFire={false}
                defaultDate={overrides?.fuels?.defaultFiscalYearDate}
                overrideActive={fuelsOverrideActive}
                overrideDate={fuelsOverrideFYDate}
                onEnabledChange={(e) => handleEnabledChange(e, true)}
                onDateChange={(date) => handleDateChange(date, true)}
                handleSave={handleFuelsSaveOverrides}
            />
            <FiscalYearOverrides
                defaultDate={overrides?.postFire?.defaultFiscalYearDate}
                isPostFire={true}
                overrideActive={postFireOverrideActive}
                overrideDate={postFireOverrideFYDate}
                onEnabledChange={(e) => handleEnabledChange(e, false)}
                onDateChange={(date) => handleDateChange(date, false)}
                handleSave={handlePostFireSaveOverrides}
            />
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                onClose={() => setSnackbarOpen(false)}
            >
                <Alert severity={snackbarSeverity} sx={{width: '100%'}} onClose={() => setSnackbarOpen(false)}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Box>
    );
}
